export const languages = [
	{ name: "Français", codeLanguage: "FR" },
	{ name: "Anglais", codeLanguage: "EN" }
];

export const FILE_TYPE_DOCUMENT = "document";
export const FILE_TYPE_WEB_PAGE = "WebPage";
export const FILE_TYPE_SITEMAP = "sitemap";
export const FILE_TYPE_HTML = "htmlText";

export const LABEL_DOCUMENT = "Document";
export const LABEL_WEB_PAGE = "Page web";
export const LABEL_SITEMAP = "Sitemap";
export const LABEL_HTML = "Html";
export const VALIDATED = "validated";
export const DRAFT = "draft";
export const PUBLISHED = "published";
export const HTMLTEXT = "htmlText";
export const ATTACHEMENTS = "attachments";

export const PRIVATE = "private";
export const PUBLIC = "public";

export const statusLabels = [
	{ label: "ASSETS.STATUS.draft", value: DRAFT },
	// { label: "ASSETS.STATUS.validated", value: VALIDATED },
	{ label: "ASSETS.STATUS.published", value: PUBLISHED }
];

export const fileTypeLabels = [
	// { label: LABEL_DOCUMENT, value: FILE_TYPE_DOCUMENT },
	{ label: LABEL_WEB_PAGE, value: FILE_TYPE_WEB_PAGE },
	{ label: LABEL_SITEMAP, value: FILE_TYPE_SITEMAP },
	{ label: LABEL_HTML, value: FILE_TYPE_HTML },
	{ label: "Images", value: "images" },
	{ label: "Videos", value: "videos" },
	{ label: "Documents", value: "documents" },
	{ label: "Css", value: "css" }
];

export const AccessLabel = [
	{ label: "ASSETS.ACCESS.public", value: PUBLIC },
	{ label: "ASSETS.ACCESS.private", value: PRIVATE }
];

export const DESC = "DESC";
export const ASC = "ASC";
